/**
 * Hover and Focus Accessibility Fixes for Aero Club Bar
 * Satisfies WCAG 1.4.13 (Content on Hover or Focus)
 */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // 1. Handle Shopify Header Menus (Details/Summary pattern)
    // Ensures menus stay open when hovered and close with Escape
    document.querySelectorAll('details[id^="Details-HeaderMenu-"], details.disclosure-has-popup').forEach(function(details) {
      const submenu = details.querySelector('ul, .header__submenu, .disclosure__list');
      if (!submenu) return;

      // Keep open when hovering the submenu itself
      details.addEventListener('mouseenter', () => { details.open = true; });
      details.addEventListener('mouseleave', () => { details.open = false; });

      // Dismiss with Escape key
      details.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          details.open = false;
          const trigger = details.querySelector('summary');
          if (trigger) trigger.focus();
          event.preventDefault();
        }
      });
    });

    // 2. Handle Tooltips and Title Attributes
    // Ensures that any element with a title attribute (which creates a tooltip)
    // can be dismissed with Escape without moving focus.
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        const activeEl = document.activeElement;
        if (activeEl && activeEl.hasAttribute('title')) {
          // Temporarily remove title to hide tooltip, then restore it
          const title = activeEl.getAttribute('title');
          activeEl.setAttribute('data-title-temp', title);
          activeEl.removeAttribute('title');
          
          // Restore after a short delay or on blur
          activeEl.addEventListener('blur', function restore() {
            activeEl.setAttribute('title', title);
            activeEl.removeAttribute('data-title-temp');
            activeEl.removeEventListener('blur', restore);
          }, { once: true });
        }
      }
    });

    // 3. Ensure persistent hover for custom tooltips
    // If you have custom CSS tooltips, this ensures they don't flicker
    const style = document.createElement('style');
    style.textContent = `
      /* Ensure hover content is persistent and hoverable */
      [data-tooltip]:hover::after,
      [data-tooltip]:focus-within::after {
        pointer-events: auto !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);
  });
})();
